import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 264,
	height: 140,
	fill: "none",
	viewBox: "0 0 264 140",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#CDD1D7",
			d: "M47.34 63.56h199.57v67.16H47.34z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			stroke: "#fff",
			strokeWidth: 2,
			d: "M63.94 2h-.7l-.24.67-23.76 67.16-.47 1.33h216.99l-.47-1.33-23.76-67.16-.23-.67H63.94Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CDD1D7",
			d: "M120.13 33.83h55.06v47.34h-55.06V33.83Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M120.13 34.93h55.06v-2.88L147.66 9.33l-27.53 22.72v2.88Zm-3.58.55h7.16v95.24h-7.16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: .45,
			d: "M136.2 37.91h22.56v32.01H136.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M137.16 40.04v-2.36h20.65v2.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			stroke: "#fff",
			strokeWidth: .23,
			d: "M137.27 40.16h9.81v9.81h-9.81zm10.03 0h10.4v9.81h-10.4zm-10.03 10.03h9.81V60h-9.81zm0 10.03h9.81v9.81h-9.81zm10.03-10.03h10.4V60h-10.4zm0 10.03h10.4v9.81h-10.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M121.94 53.92h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.57 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.57 0h1.65v16.79h-1.65zm3.59 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M179.04 66.59v7.16h-62.48v-7.16zm0-32.49v1.39h-62.48V34.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m147.57 6.85 1.85 2.13-37.47 32.4-1.84-2.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M147.57 6.85 145.73 9l36.87 31.88 1.85-2.13zm31.47 45.42v1.65h-62.48v-1.65z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M171.89 35.48h7.16v95.24h-7.16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: .45,
			d: "M55.02 81.12h22.56v32.01H55.02z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M55.96 83.26V80.9h20.65v2.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			stroke: "#fff",
			strokeWidth: .23,
			d: "M56.07 83.37h9.81v9.81h-9.81zm10.04 0h10.4v9.81h-10.4zM56.07 93.41h9.81v9.81h-9.81zm0 10.03h9.81v9.81h-9.81zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: .45,
			d: "M85.84 81.12h22.56v32.01H85.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M86.79 83.26V80.9h20.65v2.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			stroke: "#fff",
			strokeWidth: .23,
			d: "M86.9 83.37h9.81v9.81H86.9zm10.04 0h10.4v9.81h-10.4zM86.9 93.41h9.81v9.81H86.9zm0 10.03h9.81v9.81H86.9zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: .45,
			d: "M187.15 81.4h22.56v32.01h-22.56z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M188.09 83.54v-2.36h20.65v2.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			stroke: "#fff",
			strokeWidth: .23,
			d: "M188.21 83.65h9.81v9.81h-9.81zm10.04 0h10.4v9.81h-10.4zm-10.04 10.03h9.81v9.81h-9.81zm0 10.03h9.81v9.81h-9.81zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: .45,
			d: "M217.96 81.12h22.56v32.01h-22.56z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M218.9 83.26V80.9h20.66v2.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			stroke: "#fff",
			strokeWidth: .23,
			d: "M219.02 83.37h9.81v9.81h-9.81zm10.04 0h10.4v9.81h-10.4zm-10.04 10.04h9.81v9.81h-9.81zm0 10.03h9.81v9.81h-9.81zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M136.26 88.61h21.75v42.12h-21.75z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 154.84,
			cy: 110.76,
			r: .96,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			d: "M143.43 93.84h7.16v19.82h-7.16z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 14.86,
			cy: 93.29,
			fill: "#031839",
			rx: 14.86,
			ry: 22.57
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeWidth: 1.65,
			d: "m14.87 110.22 4.26-2.34m-4.41-2.34-4.27-2.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M14.05 100.44h1.65v39.36h-1.65zM263 135.68h-45.08a.13.13 0 0 1-.14-.13c-.05-.79-.25-5.09 1.52-6.95.95-1 2.83-1.68 3.77-1.96.14-.05.13-.28 0-.33-.62-.2-1.58-.62-1.9-1.27a2.27 2.27 0 0 1 0-2.2c.7-1.37 2.38-.98 3.9-.68.82.16 1.69.76 2.38 1.38.13.11.61-.22.55-.38a5.66 5.66 0 0 1-.43-2.13c.09-1.7.14-4.23 1.82-3.95 1.25.22 1.32 1.53 1.82 2.7.2.5.38 1.18.49 1.68.03.15.27.16.3.02a9.8 9.8 0 0 1 1.46-3.2c1.08-1.31 2.38-3.52 3.64-2.39.71.65.64 1.42.62 2.38 0 .13.59.39.66.29.51-.7 1.12-1.43 1.72-1.91 1.78-1.43 4.51-4.36 5.4-2.26.34.81.18 1.4 0 2.26-.17.76-.75 1.6-1.25 2.21-.1.13.1.4.25.33.7-.36 1.61-.77 2.37-.92 1.28-.24 2.6-1.07 3.32 0 .5.73.33 1.44 0 2.26-.19.48-.65.85-1.16 1.13 2.14-.6 5.22-1.1 6.05.75.52 1.14.14 3.07.03 3.57-.01.07.02.14.09.16.36.14 1.5.59 2.14 1.09 1.2.93 2.17 3.14 2.3 3.46.01.03.03.05.06.07a9.4 9.4 0 0 1 2.34 2.04c.52.75.95 2.21 1.08 2.7a.13.13 0 0 1-.13.18Zm-139.3 0H78.61a.13.13 0 0 1-.13-.13c-.06-.79-.25-5.09 1.51-6.95.95-1 2.83-1.68 3.77-1.96.14-.05.14-.28 0-.33-.62-.2-1.58-.62-1.89-1.27a2.27 2.27 0 0 1 0-2.2c.69-1.37 2.37-.98 3.89-.68.83.16 1.69.76 2.38 1.38.13.11.61-.22.55-.38a5.67 5.67 0 0 1-.43-2.13c.09-1.7.15-4.23 1.82-3.95 1.25.22 1.32 1.53 1.82 2.7.2.5.38 1.18.49 1.68.03.15.27.16.31.02a9.8 9.8 0 0 1 1.45-3.2c1.08-1.31 2.38-3.52 3.64-2.39.71.65.64 1.42.63 2.38 0 .13.58.39.65.29.51-.7 1.12-1.43 1.73-1.91 1.78-1.43 4.5-4.36 5.39-2.26.34.81.19 1.4 0 2.26-.17.76-.75 1.6-1.25 2.21-.1.13.1.4.25.33.7-.36 1.62-.77 2.38-.92 1.27-.24 2.59-1.07 3.32 0 .5.73.32 1.44 0 2.26-.2.48-.65.85-1.17 1.13 2.14-.6 5.22-1.1 6.06.75.51 1.14.13 3.07.02 3.57-.01.07.03.14.1.16.36.14 1.49.59 2.13 1.09 1.2.93 2.17 3.14 2.3 3.46l.06.07a9.35 9.35 0 0 1 2.34 2.04c.52.75.95 2.21 1.09 2.7a.14.14 0 0 1-.14.18Z"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "mask0_14130_14931",
			width: 264,
			height: 140,
			x: 0,
			y: 0,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#CDD1D7",
					d: "M47.34 63.56h199.57v67.16H47.34z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#354661",
					stroke: "#fff",
					strokeWidth: 2.2,
					d: "M63.94 1.9h-.78l-.26.73L39.15 69.8l-.52 1.47H255.9l-.52-1.47-23.75-67.17-.26-.73H63.94Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#CDD1D7",
					d: "M120.13 33.83h55.06v47.34h-55.06V33.83Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M120.13 34.93h55.06v-2.88L147.66 9.33l-27.53 22.72v2.88Zm-3.58.55h7.16v95.24h-7.16z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#fff",
					strokeWidth: .45,
					d: "M136.2 37.91h22.56v32.01H136.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M137.16 40.04v-2.36h20.65v2.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#647693",
					stroke: "#fff",
					strokeWidth: .23,
					d: "M137.27 40.16h9.81v9.81h-9.81zm10.03 0h10.4v9.81h-10.4zm-10.03 10.03h9.81V60h-9.81zm0 10.03h9.81v9.81h-9.81zm10.03-10.03h10.4V60h-10.4zm0 10.03h10.4v9.81h-10.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M121.94 53.92h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.57 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65zm3.57 0h1.65v16.79h-1.65zm3.59 0h1.65v16.79h-1.65zm3.58 0h1.65v16.79h-1.65z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M179.04 66.59v7.16h-62.48v-7.16zm0-32.49v1.39h-62.48V34.1z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m147.57 6.85 1.85 2.13-37.47 32.4-1.84-2.13z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M147.57 6.85 145.73 9l36.87 31.88 1.85-2.13zm31.47 45.42v1.65h-62.48v-1.65z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M171.89 35.48h7.16v95.24h-7.16z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#fff",
					strokeWidth: .45,
					d: "M55.02 81.12h22.56v32.01H55.02z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M55.96 83.26V80.9h20.65v2.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#647693",
					stroke: "#fff",
					strokeWidth: .23,
					d: "M56.07 83.37h9.81v9.81h-9.81zm10.04 0h10.4v9.81h-10.4zM56.07 93.41h9.81v9.81h-9.81zm0 10.03h9.81v9.81h-9.81zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#fff",
					strokeWidth: .45,
					d: "M85.84 81.12h22.56v32.01H85.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M86.79 83.26V80.9h20.65v2.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#647693",
					stroke: "#fff",
					strokeWidth: .23,
					d: "M86.9 83.37h9.81v9.81H86.9zm10.04 0h10.4v9.81h-10.4zM86.9 93.41h9.81v9.81H86.9zm0 10.03h9.81v9.81H86.9zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#fff",
					strokeWidth: .45,
					d: "M187.15 81.4h22.56v32.01h-22.56z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M188.09 83.54v-2.36h20.65v2.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#647693",
					stroke: "#fff",
					strokeWidth: .23,
					d: "M188.21 83.65h9.81v9.81h-9.81zm10.04 0h10.4v9.81h-10.4zm-10.04 10.03h9.81v9.81h-9.81zm0 10.03h9.81v9.81h-9.81zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#fff",
					strokeWidth: .45,
					d: "M217.96 81.12h22.56v32.01h-22.56z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M218.9 83.26V80.9h20.66v2.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#647693",
					stroke: "#fff",
					strokeWidth: .23,
					d: "M219.02 83.37h9.81v9.81h-9.81zm10.04 0h10.4v9.81h-10.4zm-10.04 10.04h9.81v9.81h-9.81zm0 10.03h9.81v9.81h-9.81zm10.04-10.03h10.4v9.81h-10.4zm0 10.03h10.4v9.81h-10.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#354661",
					d: "M136.26 88.61h21.75v42.12h-21.75z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 154.84,
					cy: 110.76,
					r: .96,
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#647693",
					d: "M143.43 93.84h7.16v19.82h-7.16z"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 14.86,
					cy: 93.29,
					fill: "#237D45",
					rx: 14.86,
					ry: 22.57
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#992A2A",
					strokeWidth: 1.65,
					d: "m14.87 110.22 4.26-2.34m-4.41-2.34-4.27-2.34"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#992A2A",
					d: "M14.05 100.44h1.65v39.36h-1.65z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#237D45",
					d: "M263 135.68h-45.08a.13.13 0 0 1-.14-.13c-.05-.79-.25-5.09 1.52-6.95.95-1 2.83-1.68 3.77-1.96.14-.05.13-.28 0-.33-.62-.2-1.58-.62-1.9-1.27a2.27 2.27 0 0 1 0-2.2c.7-1.37 2.38-.98 3.9-.68.82.16 1.69.76 2.38 1.38.13.11.61-.22.55-.38a5.66 5.66 0 0 1-.43-2.13c.09-1.7.14-4.23 1.82-3.95 1.25.22 1.32 1.53 1.82 2.7.2.5.38 1.18.49 1.68.03.15.27.16.3.02a9.8 9.8 0 0 1 1.46-3.2c1.08-1.31 2.38-3.52 3.64-2.39.71.65.64 1.42.62 2.38 0 .13.59.39.66.29.51-.7 1.12-1.43 1.72-1.91 1.78-1.43 4.51-4.36 5.4-2.26.34.81.18 1.4 0 2.26-.17.76-.75 1.6-1.25 2.21-.1.13.1.4.25.33.7-.36 1.61-.77 2.37-.92 1.28-.24 2.6-1.07 3.32 0 .5.73.33 1.44 0 2.26-.19.48-.65.85-1.16 1.13 2.14-.6 5.22-1.1 6.05.75.52 1.14.14 3.07.03 3.57-.01.07.02.14.09.16.36.14 1.5.59 2.14 1.09 1.2.93 2.17 3.14 2.3 3.46.01.03.03.05.06.07a9.4 9.4 0 0 1 2.34 2.04c.52.75.95 2.21 1.08 2.7a.13.13 0 0 1-.13.18Zm-139.3 0H78.61a.13.13 0 0 1-.13-.13c-.06-.79-.25-5.09 1.51-6.95.95-1 2.83-1.68 3.77-1.96.14-.05.14-.28 0-.33-.62-.2-1.58-.62-1.89-1.27a2.27 2.27 0 0 1 0-2.2c.69-1.37 2.37-.98 3.89-.68.83.16 1.69.76 2.38 1.38.13.11.61-.22.55-.38a5.67 5.67 0 0 1-.43-2.13c.09-1.7.15-4.23 1.82-3.95 1.25.22 1.32 1.53 1.82 2.7.2.5.38 1.18.49 1.68.03.15.27.16.31.02a9.8 9.8 0 0 1 1.45-3.2c1.08-1.31 2.38-3.52 3.64-2.39.71.65.64 1.42.63 2.38 0 .13.58.39.65.29.51-.7 1.12-1.43 1.73-1.91 1.78-1.43 4.5-4.36 5.39-2.26.34.81.19 1.4 0 2.26-.17.76-.75 1.6-1.25 2.21-.1.13.1.4.25.33.7-.36 1.62-.77 2.38-.92 1.27-.24 2.59-1.07 3.32 0 .5.73.32 1.44 0 2.26-.2.48-.65.85-1.17 1.13 2.14-.6 5.22-1.1 6.06.75.51 1.14.13 3.07.02 3.57-.01.07.03.14.1.16.36.14 1.49.59 2.13 1.09 1.2.93 2.17 3.14 2.3 3.46l.06.07a9.35 9.35 0 0 1 2.34 2.04c.52.75.95 2.21 1.09 2.7a.14.14 0 0 1-.14.18Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_14130_14931)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#031839",
				fillOpacity: .29,
				d: "M-1.46.08h263.97v138.55H-1.46z"
			})
		})
	]
});
const SvgHouse = styled(base)({});
export default SvgHouse;
